// @flow

import PropTypes from 'prop-types';

export default PropTypes.shape({
  access: PropTypes.arrayOf(PropTypes.string),
  ad_match_reason: PropTypes.number,
  aggregated_pin_data: PropTypes.shape({
    aggregated_stats: PropTypes.shape({
      done: PropTypes.number,
      likes: PropTypes.number,
      saves: PropTypes.number,
    }),
    pin_tags: PropTypes.arrayOf(
      PropTypes.shape({
        pin_tag_key: PropTypes.string.isRequired,
        x_percent: PropTypes.number.isRequired,
        y_percent: PropTypes.number.isRequired,
      }),
    ),
  }),
  attribution: PropTypes.shape({
    embed: PropTypes.shape({
      src: PropTypes.string,
    }),
  }),
  board: PropTypes.shape({
    followed_by_me: PropTypes.bool,
    id: PropTypes.string,
    url: PropTypes.string,
    name: PropTypes.string,
  }),
  buyable_product: PropTypes.shape({
    display_active_max_price: PropTypes.string,
    display_active_min_price: PropTypes.string,
    short_description: PropTypes.string,
    title: PropTypes.string,
  }),
  debug_info_html: PropTypes.string,
  description: PropTypes.string,
  domain: PropTypes.string,
  dominant_color: PropTypes.string,
  done_by_me: PropTypes.bool,
  embed: PropTypes.shape({
    src: PropTypes.string,
    type: PropTypes.string,
  }),
  id: PropTypes.string,
  images: PropTypes.shape({
    '236x': PropTypes.shape({
      url: PropTypes.string,
      height: PropTypes.number,
    }),
    '474x': PropTypes.shape({
      url: PropTypes.string,
      height: PropTypes.number,
    }),
  }),
  image_signature: PropTypes.string,
  is_quick_promotable: PropTypes.bool,
  is_eligible_for_web_closeup: PropTypes.bool,
  is_native: PropTypes.bool,
  link: PropTypes.string,
  native_creator: PropTypes.shape({
    username: PropTypes.string,
    full_name: PropTypes.string,
    id: PropTypes.string,
    image_small_url: PropTypes.string,
  }),
  per_pin_analytics: PropTypes.shape({
    clickthrough: PropTypes.number,
    closeup: PropTypes.number,
    id: PropTypes.string,
    impression: PropTypes.number,
    repin: PropTypes.number,
    total_engagement: PropTypes.number,
    type: PropTypes.string,
  }),
  pinner: PropTypes.shape({
    explicitly_followed_by_me: PropTypes.bool,
    full_name: PropTypes.string,
    id: PropTypes.string,
    image_small_url: PropTypes.string,
  }),
  promoter: PropTypes.shape({
    username: PropTypes.string,
    full_name: PropTypes.string,
    image_small_url: PropTypes.string,
  }),
  recommendationReason: PropTypes.shape({
    reason: PropTypes.string,
    board: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      url: PropTypes.string,
    }),
    interest: PropTypes.shape({
      id: PropTypes.string,
    }),
    pin: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  repin_count: PropTypes.number,
  rich_summary: PropTypes.shape({
    display_name: PropTypes.string,
  }),
  source_interest: PropTypes.shape({
    name: PropTypes.string,
    url_name: PropTypes.string,
    id: PropTypes.string,
  }),
  tracked_link: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  videos: PropTypes.shape({}),
  saved: PropTypes.bool,
});
